export const isBlacklisted = name => {
  const re = /(^(cht|pt)$|^chroma)/gi;
  return re.test(name);
};
